var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.537 11.743c0 5.933-4.81 10.743-10.745 10.743S1.047 17.676 1.047 11.743C1.047 5.81 5.857 1 11.792 1c5.934 0 10.745 4.81 10.745 10.743z",
    stroke: "#7D80DA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.049 9.5a3.5 3.5 0 1 1-7.001 0 3.5 3.5 0 0 1 7 0zm-11.002 10c.5-1.833 2.7-5.5 7.501-5.5s7.168 3.667 7.502 5.5",
    stroke: "#7D80DA",
    strokeWidth: 2
  })));
};
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMi41MzcgMTEuNzQzYzAgNS45MzMtNC44MSAxMC43NDMtMTAuNzQ1IDEwLjc0M1MxLjA0NyAxNy42NzYgMS4wNDcgMTEuNzQzQzEuMDQ3IDUuODEgNS44NTcgMSAxMS43OTIgMWM1LjkzNCAwIDEwLjc0NSA0LjgxIDEwLjc0NSAxMC43NDN6IiBzdHJva2U9IiM3RDgwREEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggZD0iTTE1LjA0OSA5LjVhMy41IDMuNSAwIDEgMS03LjAwMSAwIDMuNSAzLjUgMCAwIDEgNyAwek00LjA0NyAxOS41Yy41LTEuODMzIDIuNy01LjUgNy41MDEtNS41czcuMTY4IDMuNjY3IDcuNTAyIDUuNSIgc3Ryb2tlPSIjN0Q4MERBIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";